import { AddIcon, GiftIcon, SendIcon } from '@treams/treams-icons';
import { Route, useHistory } from '@treams/treams-routes';
import { Button, Popover } from '@treams/treams-ui';
import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';
import * as graphql from 'generated/graphql';

import useFeature from '../packages/kakapo-ui-application/hooks/useFeature';
import ComplimentRecipientSelector from './ComplimentRecipientSelector';

export default function ViewerFeedbackButtons() {
	const history = useHistory();
	const { t } = useTranslation();
	const hasCompliments = useFeature(graphql.FeatureName.Compliments);
	const canRequestFeedback = useFeature(graphql.FeatureName.FeedbackAdhoc);
	const canGiveFeedback = useFeature(graphql.FeatureName.FeedbackSpontaneous);

	return (
		<>
			{canRequestFeedback && (
				<Box mb={2}>
					<Button
						icon={<AddIcon />}
						title={t('feedback.index.new')}
						link="/feedback/request-from-moment"
					/>
				</Box>
			)}

			{canGiveFeedback && (
				<Box mb={2}>
					<Button
						icon={<SendIcon />}
						title={t('feedback.index.send')}
						link="/feedback/send"
						type="secondary"
					/>
				</Box>
			)}

			{hasCompliments && (
				<Route path="/feedback/compliments/new">
					{({ match }) => (
						<Popover.Target
							center
							visible={!!match}
							contents={
								<ComplimentRecipientSelector
									onDismiss={() => history.push('/feedback/compliments')}
								/>
							}
							onDismiss={() => history.push('/feedback/compliments')}
						>
							<Button
								type="secondary"
								icon={<GiftIcon />}
								title={t('compliments.index.new')}
								link="/feedback/compliments/new"
							/>
						</Popover.Target>
					)}
				</Route>
			)}
		</>
	);
}
